import type { RequiredGeneric } from '@pba/utils';
import { TextInput } from 'ui';
import { ChangePasswordFormContent, type ChangePasswordFormContentValues } from 'features/settings';

export type NewPasswordExpiredFormValues = {
  email: string;
} & ChangePasswordFormContentValues;

const NewPasswordExpiredFormContent = <T extends NewPasswordExpiredFormValues = never>(_: RequiredGeneric<T>) => (
  <>
    <TextInput
      input={{
        autoComplete: 'email',
      }}
      item={{
        label: 'Email',
        name: 'email',
        rules: [
          {
            type: 'email',
          },
          {
            required: true,
            whitespace: true,
          },
        ],
      }}
    />

    <ChangePasswordFormContent<NewPasswordExpiredFormValues> />
  </>
);

export default NewPasswordExpiredFormContent;
